import React from 'react';
import { InventoryProvider } from '@warehouse/quickbase';
import { InventoryQuickbase } from './Inventory';

export function Inventory() {
	return (
		<InventoryProvider>
			<InventoryQuickbase />
		</InventoryProvider>
	);
}
